import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getOwners, createOrUpdateRequest } from './actions';
import {
  ownerListData,
  ownerListFetched,
  ownerListLoading,
  currentItemSelector,
  ownerCreateOrUpdateInProcessSelector,
  ownerCreateOrUpdateErrorsSelector,
} from './selectors';
import routeCodes from '../../common/constants/route-codes';
import { useUser } from '../user/use-user';

export const useOwner = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isSuperAdmin } = useUser();
  const listData = useSelector(ownerListData);
  const listLoading = useSelector(ownerListLoading);
  const listFetched = useSelector(ownerListFetched);
  const currentItem = useSelector(currentItemSelector);
  const createOrUpdateInProcess = useSelector(
    ownerCreateOrUpdateInProcessSelector,
  );
  const createOrUpdateErrors = useSelector(ownerCreateOrUpdateErrorsSelector);

  const handleFetchInitialList = () => {
    if (!listFetched) {
      dispatch(getOwners());
    }
  };

  const handleCreateOrUpdate = (payload, id) => {
    const afterSuccess = () => {
      history.push(isSuperAdmin ? routeCodes.superAdmin.administrationOwners : routeCodes.profile);
    };
    dispatch(createOrUpdateRequest({ id, formData: payload, afterSuccess }));
  };

  return {
    listData,
    listLoading,
    handleFetchInitialList,
    handleCreateOrUpdate,
    currentItem,
    createOrUpdateInProcess,
    createOrUpdateErrors,
  };
};
